var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","dark":"","padless":"","absolute":""}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":""}},[_c('v-card-text',{staticClass:"black py-3 white--text text-center"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }